<script>
import RequestToJoinUConnectCorporateDialog from "../../../common/requestToJoinUConnectCorporateDialog.vue";

export default {
  name: "packageCard",
  components: {RequestToJoinUConnectCorporateDialog},

  data() {
    return {
      requestToJoinDialogVisible: false
    }
  },
  props: {
    plan: {
      type: Object,
      default: () => {
        return {};
      }
    },
    subscriptionPeriod: {
      type: String,
      default: () => {
        return 'MONTHLY';
      }
    }
  },
  methods: {
    getFeatureList(info){
      let features;
      try{
        features = JSON.parse(info).features.common;
      }catch (e) {
        console.log("Common:",e);
      }
      return features;

    },
    getStandoutFeatureList(info){
      let standoutFeatures;
      try {
        standoutFeatures = JSON.parse(info).features.standoutFeatures;
      }catch (e) {
        console.log("standoutFeatures:",e);
      }
      return standoutFeatures;
    },

    subscribeNow(productId) {

      this.$emit('selectedPackage', productId)
    },
    isString(val) {
      return typeof val === 'string' || val instanceof String;
    },
    isMostPopularPackage(){
      // average users pick
    },
    contactUs() {
      this.requestToJoinDialogVisible = true;

    },
    generateDisplayPrice(plan, subscriptionPeriod) {

      let prodCode = plan.uconnectSubscription.productCode;
      return prodCode === 'UCON_STND_FREE' || prodCode === "UCON_CORP_PREM"
        ? plan.displayPrice
        : "$" +  Math.trunc(subscriptionPeriod === 'YEARLY' ?  plan.productDetails.yearlyPrice.price : plan.displayPrice);
    },
    generateAlternateDisplayPrice(plan, subscriptionPeriod) {

      let prodCode = plan.uconnectSubscription.productCode;
      return prodCode === 'UCON_STND_FREE' || prodCode === "UCON_CORP_PREM"
        ? 0
        : "$" +  Math.trunc(subscriptionPeriod != 'YEARLY' ?  plan.productDetails.yearlyPrice.price : plan.displayPrice) +" AUD";
    },
    getDescription(info) {
      let description = "";
      try{
        description = JSON.parse(info).features.description;
      }catch (e) {
        console.log("Common:",e);
      }
      return description;
    },
  }
}
</script>

<template>
  <el-card shadow="hover">
    <!--    <el-tag v-if="isMostPopularPackage()" class="current-tag" type="success">Most Popular</el-tag>-->
    <template #header>
      <div class="card-header">
        <span>{{ plan.displayName }}</span>
        <div class="price">
          {{ generateDisplayPrice(plan, subscriptionPeriod) }}
          <div class="price-details">
            <span class="currency">AUD</span>
            <span class="period">/{{ subscriptionPeriod === 'MONTHLY' ? 'mo' : 'yr' }}</span>
          </div>
        </div>
        <div v-if="plan.uconnectSubscription.productCode != 'UCON_STND_FREE'" class="billed">billed {{ subscriptionPeriod === 'MONTHLY' ? 'monthly' : 'annually' }}</div>
        <div v-else class="billed free"></div>

        <!--Alternative Fees-->
        <div v-if="plan.uconnectSubscription.productCode === 'UCON_STND_BAS' || plan.uconnectSubscription.productCode === 'UCON_STND_PRO' || plan.uconnectSubscription.productCode === 'UCON_STND_ELITE' || plan.uconnectSubscription.productCode === 'UCON_STND_ELITE_NEW' " class="billed annual"> {{ generateAlternateDisplayPrice(plan, subscriptionPeriod) }} /{{ subscriptionPeriod != 'MONTHLY' ? 'monthly' : 'annually' }}</div>
        <div v-else-if="plan.uconnectSubscription.productCode === 'UCON_CORP_PREM' " class="billed annual"> Custom AUD /{{ subscriptionPeriod != 'MONTHLY' ? 'monthly' : 'annually' }}</div>
        <div v-else class="billed free"></div>
      </div>
    </template>

    <div class="description">{{getDescription(plan.uconnectSubscription.info)}}</div>
    <div class="features" style="min-height: 100px">
      <ul>
        <li v-for="(feature, index) in getFeatureList(plan.uconnectSubscription.info)" :key="index">
          <template v-if="isString(feature)">
            <i class="el-icon-check"></i>
            <span v-html="feature"></span>
          </template>
          <template  v-else-if="Array.isArray(feature)">
            <ul>
              <li v-for="(item, index) in feature" :key="index">
                <i class="el-icon-check"></i>
                <span v-html="item"></span>
              </li>
            </ul>
          </template>
        </li>
      </ul>

    </div>
<!--    <div class="standout" style="min-height: 228px">-->
<!--      <strong>Standout features</strong>-->
<!--      <ul>-->
<!--        <li v-for="(standoutFeature, index) in getStandoutFeatureList(plan.uconnectSubscription.info)" :key="index">-->
<!--          <template v-if="isString(standoutFeature)">-->
<!--            <i class="el-icon-check"></i>-->
<!--            <span v-html="standoutFeature"></span>-->
<!--          </template>-->
<!--          <template  v-else-if="Array.isArray(standoutFeature)">-->
<!--            <ul>-->
<!--              <li v-for="(item, index) in standoutFeature" :key="index">-->
<!--                <i class="el-icon-caret-right"></i>-->
<!--                <span v-html="item"></span>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </template>-->

<!--        </li>-->
<!--      </ul>-->
<!--    </div>-->
    <el-button v-if="plan.uconnectSubscription.subscriptionType === 'U_CON_CORP'" class="action-btn" type="primary" @click="contactUs()" >Contact us</el-button>
    <el-button v-else  class="action-btn" type="primary" @click="subscribeNow(plan.uconnectSubscription.id)" >Sign up now</el-button>


    <request-to-join-u-connect-corporate-dialog v-if="requestToJoinDialogVisible" :request-to-join-dialog-visible="requestToJoinDialogVisible" @onClose="requestToJoinDialogVisible = false"/>
  </el-card>


</template>

<style scoped lang="css">

.el-card {
  margin: 10px;
  color: #003333;
  border-radius: 10px;
  position: relative; /* Required for absolute positioning of the tag */
}

.card-header {
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 10px;
}

.price {
  display: flex;
  font-size: 36px;
  font-weight: bold;
  margin-top: 15px;
  margin-bottom: 5px;
}
.price-details {
  display: flex;
  flex-direction: column;
  margin-left: 5px;
  line-height: 1;
}
.currency {
  font-size: 16px;
  font-weight: normal;
  margin-top: 2px;
}

.period {
  font-size: 14px;
  font-weight: normal;
}

.billed {
  color: #999;
  margin-bottom: 20px;
}
.annual {
  color: #666666;
}
.free {
  color: #999;
  margin-bottom: 35px;
}
.description {
  font-size: 15px;
  color: #003333;
  font-weight: 500;
  margin-bottom: 20px;
}
.features ul,
.standout ul {
  list-style: none;
  padding-left: 0;
  margin-bottom: 20px;
  text-align: left;
}

.features li,
.standout li {
  margin-bottom: 5px;
  color: #003333;
}
.features li ul,
.standout li ul {
  margin-left: 20px;
}

.features i,
.standout i {
  color: #003333;
  margin-right: 5px;
}

.standout {
  margin-bottom: 20px;
  text-align: left;
}



.action-btn {
  width: 100%;
  margin-top: 10px;
  color: #ffffff;
  background: #003333;
  border-color: #003333;
}
.current-tag {
  position: absolute;
  top: 9px;
  right: 2px;
  z-index: 1; /* Ensure it's above other elements */
}
</style>



// WEBPACK FOOTER //
// src/components/register/uConnectRegistration/selectPackage/packageCard.vue